export enum Route {
  CANDIDATE_PROFILE = "candidate-profile",
  CANDIDATES_SEARCH = "candidates-search",
  CANDIDATES_LISTING = "candidates-listing",
  JOB_OFFERS_LISTING_ACTIVE = "job-offers-listing-active",
  JOB_OFFERS_LISTING_INACTIVE = "job-offers-listing-inactive",
  JOB_OFFERS_LISTING_DRAFT = "job-offers-listing-draft",
  JOB_OFFER_ADD_STANDARD_PLUS = "job-offer-add-standard-plus",
  JOB_OFFER_ADD_PREMIUM = "job-offer-add-premium",
  JOB_OFFER_ADD_PRO = "job-offer-add-pro",
  JOB_OFFER_EDIT = "job-offer-edit",
  JOB_OFFER_DRAFT_EDIT = "job-offer-draft-edit",
  JOB_OFFER_COPY = "job-offer-copy",
  JOB_OFFER_RESUME = "job-offer-resume",
  JOB_OFFER_TEMPLATES_LISTING = "job-offer-templates-listing",
  JOB_OFFER_ADD_TEMPLATE = "job-offer-add-template",
  JOB_OFFER_EDIT_TEMPLATE = "job-offer-edit-template",
  USER_NOT_ALLOWED = "user-not-allowed",
}
